module.exports = __webpack_public_path__ + "static/media/claim.4079e94d.svg";